import { IOrderApprovalHistoryHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

interface IProps {
  orderId?: string;
  customerId?: string;
  registrationNumber?: string;
}

export const useOrderApprovalHistory = ({
  orderId,
  customerId,
  registrationNumber,
}: IProps): IOrderApprovalHistoryHook => {
  const { orderStore } = useStore();
  const {
    approvalHistory,
    approvalHistoryTotalCount,
    approvalHistoryCurrentPage,
    approvalHistorySkipCount,
    approvalHistoryMaxResultCount,
    approvalHistoryLoading,
    handleApprovalHistoryPageChange,
  } = orderStore;

  useEffect(() => {
    return () => orderStore.resetApprovalHistory();
  }, [orderStore]);

  useEffect(() => {
    const hasFilter = orderId || (customerId && registrationNumber);
    if (!hasFilter) return;

    orderStore.getApprovalHistory({
      orderId,
      customerId,
      vrm: registrationNumber,
      skipCount: approvalHistorySkipCount,
      maxResultCount: approvalHistoryMaxResultCount,
    });

    return () => {
      orderStore.clearApprovalHistory();
    };
  }, [orderStore, orderId, customerId, registrationNumber, approvalHistorySkipCount, approvalHistoryMaxResultCount]);

  return {
    loading: approvalHistoryLoading,
    dataSource: Array.from(approvalHistory.values()),
    totalCount: approvalHistoryTotalCount,
    skipCount: approvalHistorySkipCount,
    currentPage: approvalHistoryCurrentPage,
    maxResultCount: approvalHistoryMaxResultCount,
    handlePageChange: handleApprovalHistoryPageChange,
  };
};
